var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthChecks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127 127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#cfccec",
    cx: 63.5,
    cy: 63.61,
    r: 63.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#726fb3",
    d: "M102.32,36.49c-.75-.75-1.7-1.14-2.77-1.14h0c-1.06,0-2.02.39-2.76,1.14l-45.93,45.93-20.66-20.66c-.75-.75-1.71-1.15-2.77-1.15s-2.02.4-2.76,1.15h0c-.75.76-1.14,1.71-1.14,2.78,0,1.06.39,2.02,1.14,2.76l23.44,23.44c.75.75,1.7,1.14,2.76,1.14s2.02-.39,2.76-1.14l48.69-48.69c.76-.76,1.16-1.72,1.16-2.79,0-1.05-.4-2-1.15-2.75h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthChecks);
export default __webpack_public_path__ + "static/media/health-checks.92575e8bfd4ab0b713259c0df8d3ff35.svg";
export { ForwardRef as ReactComponent };